import { Fragment } from "react/jsx-runtime";

import { useCardDisplaySettingsLocalStorage } from "../../../_hooks";
import * as Model from "../../../has-time-limit/model";
import { Timeline, TimelinePanel } from "../../../has-time-limit/ui/timeline";

import type * as Repository from "../../../_repository";

type Props = {
	hotelID: string;
	// 検索日
	searchDate: string;
	// オプションリスト
	optionPmsActiveListQueryData: Repository.Query.QueryData.OptionPmsList.OptionPmsActiveListQueryData;
	optionPmsColorListQueryData: Repository.Query.QueryData.OptionPmsColorListQueryData;
};

export const PrintTimelineForOptionPms = ({
	hotelID,
	searchDate,
	optionPmsActiveListQueryData,
	optionPmsColorListQueryData,
}: Props) => {
	const { settings } = useCardDisplaySettingsLocalStorage(hotelID);

	/**
	 * 初期化
	 */
	const {
		//
		viewData,
		//
	} = Model.UseCase.useInitialized({
		hotelID,
		optionPmsActiveListQueryData,
		optionPmsColorListQueryData,
		groupByOptionID: settings.groupByOptionID,
	});

	return (
		<div className="space-y-12 py-8">
			<div className="grid grid-cols-1 gap-2 tablet:grid-cols-2">
				{viewData.activeOptionColorList.map(({ color, optionNameText }, index) => (
					<div key={index} className="flex items-center gap-x-2">
						<label className="min-h-3 min-w-3 rounded-full" style={{ background: color }} />

						<p className="line-clamp-3 text-xs">{optionNameText}</p>
					</div>
				))}
			</div>

			<div className="h-full w-fit overflow-y-auto rounded border p-3">
				<Timeline
					firstOptionStartAt={viewData.firstOptionStartAt}
					lastOptionEndAt={viewData.lastOptionEndAt}
					searchDate={searchDate}
					panelAreaMinWidth={viewData.panelAreaMinWidth}
					panelChildren={viewData.timelinePanelItemList.map((item, index) => {
						return (
							<Fragment key={index}>
								<TimelinePanel
									cardId={item.cardId}
									guestName={item.guestName}
									memo={item.memo}
									subOptionName={item.subOptionName}
									guestTotalNumberText={item.guestTotalNumberText}
									showSubOptionName={settings.showSubOptionName}
									showGuestTotalNumber={settings.showGuestTotalNumber}
									color={item.color}
									height={item.height}
									top={item.top}
									left={item.left}
									onClickPanel={() => { }}
								/>
							</Fragment>
						);
					})}
				/>
			</div>
		</div>
	);
};
